import { Body1Strong, Button, Link, makeStyles, tokens, Toolbar } from "@fluentui/react-components";
import { bundleIcon, DismissFilled, DismissRegular } from "@fluentui/react-icons";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
    },
    toolbar: {
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        padding: "0.25rem"
    },
    infoGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "0.5rem",
        border: "1px solid " + tokens.colorNeutralStroke1,
        padding: "1rem",
        borderRadius: tokens.borderRadiusMedium
    },
    infoGrid__col: {
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem"
    },
    infoGrid__col__item: {
        display: "flex",
        gap: "0.5rem"
    }
});

const DismissIcon = bundleIcon( DismissFilled, DismissRegular );

export default function FlightOps_Branch_Overview() {
    const styles = useStyles();
    
    return (
        <div className={styles.root}>
            <Toolbar className={styles.toolbar}>
                <Button appearance="subtle" icon={<DismissIcon />}>
                    Delete Branch
                </Button>
            </Toolbar>

            <div className={styles.infoGrid}>
                <div className={styles.infoGrid__col}>
                    <div className={styles.infoGrid__col__item}>
                        <Body1Strong>Default branch:</Body1Strong>
                        <span>No (<Link>make default</Link>)</span>
                    </div>
                </div>
                <div className={styles.infoGrid__col}>
                    <div className={styles.infoGrid__col__item}>
                        <Body1Strong>Rings:</Body1Strong>
                        <span>3 (<Link>configure</Link>)</span>
                    </div>
                </div>
                <div className={styles.infoGrid__col}>
                    <div className={styles.infoGrid__col__item}>
                        <Body1Strong>Public:</Body1Strong>
                        <span>No (<Link>change</Link>)</span>
                    </div>
                </div>
            </div>
        </div>
    );
}